export { default as Price } from './Price';
export type { PriceProps } from './Price';
